var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailinputicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5628 9.50317C12.0921 9.78288 11.5516 9.93138 11 9.93138C10.4484 9.93138 9.90786 9.78288 9.43643 9.5016L0 3.90967V14.0642C0 15.3607 1.05286 16.4214 2.35714 16.4214H19.6429C20.9471 16.4214 22 15.3607 22 14.0642V3.90967L12.5628 9.50317Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1584 8.28614C10.413 8.43779 10.7029 8.51714 10.9999 8.51714C11.2969 8.51714 11.5876 8.437 11.8406 8.28693L21.9913 2.27071C21.9449 1.01514 20.9172 0 19.6428 0H2.35705C1.08262 0 0.0549021 1.01514 0.00854492 2.27071L10.1584 8.28614Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailinputicon);
export default __webpack_public_path__ + "static/media/emailinputicon.cbc24ba933376865c132cb63d7809913.svg";
export { ForwardRef as ReactComponent };